import {
    IonButton,
    IonCard,
    IonCardContent,
    IonContent,
    IonIcon,
    IonImg,
    IonPage,
    IonSpinner,
    IonText,
} from "@ionic/react";
import { useContext, useEffect, useMemo, useState } from "react";
import { Context } from "../MyContext";
import "../theme/PhotoPreview.css";
import "../theme/Utilities.css";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import { ImageResource, OrientResource } from "../common/types";
import { orientationTransform } from '../common/orientation-transform';
import  CameraOverlay  from "../components/CameraOverlay";
import { chevronForwardOutline, refreshOutline } from "ionicons/icons";
import { uploadImage, AuthProvider } from "../pt/utils/http-service"; 
import { ClientDataHolder } from "../pt/dashboard/data/data";
const PhotoCapture: React.FC = () => {
    const history = useHistory();
    //const auth = new AuthProvider(useAuth0().getAccessTokenSilently);
    const auth = new AuthProvider(()=>Promise.resolve("fix-ugly-later"), undefined, undefined, undefined, true);
    const { profileID, sessionID, gender, pose } = useParams<{ profileID: string, sessionID: string, gender: string, pose: 'front'|'right' }>();
    const [client] = useState<ClientDataHolder>(new ClientDataHolder(profileID, auth));
    const addResource = client.addResourceToSession;
    const getResource = client.getResourceFromSession;
   
    
    const [uploaded, setUploaded] = useState(false);

    const { setFrontMaskDone, setFrontImgDone } = useContext(Context);
    const [image, setImage] = useState<ImageResource>();
    const [objectMask, setObjectMask] = useState<ImageResource>();
    const [orientation, setOrientation] = useState<OrientResource>();
    const which = "ready";
    const [error, setError] = useState("")
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        setImage(undefined)
        setObjectMask(undefined)
        setFrontImgDone(false)
        setFrontMaskDone(false)
        setUploaded(false)
    }, [pose])


    const fetchImage = async () => {
        let i = 0;
        while (i < 5) {
            try {
                let response = await  getResource(sessionID, `${pose}_img`);
                console.log("Fetched image", response);
                setImage(response);
                return;
            } catch (error: any) {
                console.error(error);
            }
            await new Promise((resolve) => setTimeout(resolve, 500));
            i++;
        }
    };

    const fetchMask = async () => {

        try {
            let response = await getResource(sessionID, `${pose}_mask`);
            setObjectMask(response);
            if (response.status === 200) return;
        } catch (error: any) {
            console.error(error);
        }
    };

    const fetchOrientation = async () => {
        try {
            let response = await getResource(sessionID, `${pose}_orient`);
            setOrientation(response);
            if (response.status === 200) return;
        } catch (error: any) {
            console.error(error);
        }
    };
    const optimizeImages = async () => {

        console.log("Optimizing images", which);
        let response = await addResource(sessionID,which, { createdBy: "app-alpha1" }, true);
        console.log("Optimizing images", response.status, response);
    };

    const maskTransform = useMemo(() => {
        return orientationTransform(orientation?.orient);
    }, [orientation]);

    const uploadPhoto = async (photo: string, orientation: any) => {
        setUploaded(true);
        setIsLoading(true);
        setError("");
       
        let response = await addResource(sessionID, `${pose}_angle`, { "beta": orientation.beta, "alpha": orientation.alpha, "gamma": orientation.gamma }, true);
        const imgResource = { pixels: photo.split(",")[1], createdBy: "pro" }
        response = await uploadImage(profileID, sessionID, pose, photo, gender, pose === 'front', auth);
        setUploaded(true);
        setImage({...imgResource, id:"temp", createdAt: new Date().toISOString()});
        
        const body = await response.json();
        setIsLoading(false);
        console.log("Photo taken", response.status, body);
        if (response.status >= 400) {
            const reason = body?.reason || body?.error || "Error uploading image, please retake photo";
            console.log("Upload rejected", response.status, reason);
            setError(reason);
            await fetchImage();
            return;
        }
        if (body.status === 'rejected') {
            const isDev = window.location.hostname.includes('dev') || window.location.hostname.includes('localhost');
            const reason = isDev
                ? (body.reason || "Image rejected")
                : "The photo could not be processed. Please retake the photo following the instructions.";
            console.log("Upload rejected by rembg:", body.reason, "backend:", body.backend);
            setError(reason);
            // Mask is still returned on rejection — show overlay
            if (body.pixels) {
                setObjectMask({ pixels: body.pixels, id: "rejected", createdAt: new Date().toISOString() });
                if (body.orient !== undefined) {
                    setOrientation({ orient: body.orient, id: "rejected", createdAt: new Date().toISOString() });
                }
            }
            return;
        }
        await Promise.all([fetchMask(), fetchOrientation()]);
        setIsLoading(false);

        setFrontMaskDone(true);
    }
    return (
        <IonPage className="z-50">
    
            {!uploaded ? <IonContent fullscreen>
                <CameraOverlay setUploaded={() => {}} sessionID={sessionID} profileID={profileID} pose={pose} gender={gender} uploadPhoto={uploadPhoto} />

            </IonContent> : <IonContent   fullscreen>
                {isLoading ? (
                    <div className="loadingIconText">
                        <div className="loadingIcon">
                            <IonSpinner name="lines-sharp"></IonSpinner>
                        </div>
                        <br></br>
                        <br></br>
                        <IonText className="loadingText">
                            <h1>Please wait...</h1>
                        </IonText>
                    </div>
                ) : (
                    <><div className="previewImageContainer">
                        <IonImg
                            src={`data:image/png;base64,${image?.pixels}`}
                            className="previewImage"
                            style={{ width: 420, height: 420 }} />
                        {objectMask?.pixels ? <div className="previewMaskOverlay"><IonImg
                            src={`data:image/png;base64,${objectMask?.pixels}`}
                            className="previewMask"
                            style={{ transform: `${maskTransform}`, width: 420, height: 420 }} /></div> : <></>}
                    </div><IonCard  className="text-xl" color={error ? 'warning' : 'light'}>
                        <IonCardContent className="text-center">
                            <IonText className="text-2xl">
                            {error.length>0 ? <>{error}</> : <>Is the entire person correctly highlighted in <b className="text-green-500" >green</b>? If not, please retake the photo.</>}
                            </IonText>
                            </IonCardContent>
                    
                        </IonCard><div className="buttons">
                            <IonButton size="large" fill="outline" color={"warning"} onClick={() => {
                                setUploaded(false)
                                setFrontMaskDone(false)
                                setFrontImgDone(false)

                            }}>
                                Retake photo <IonIcon src={refreshOutline}></IonIcon>
                            </IonButton>

                            {!error && (pose === 'front' ? <IonButton size="large" fill="outline" onClick={() => history.push(`/sessions/${profileID}/${sessionID}/${gender}/right_img`)}>
                                Continue <IonIcon src={chevronForwardOutline}></IonIcon>
                            </IonButton> : <IonButton size="large" fill="outline" onClick={() => { optimizeImages(); history.push(`/sessions/${profileID}/${sessionID}/${gender}/result`); }}>
                                See results <IonIcon src={chevronForwardOutline}></IonIcon>
                            </IonButton>)
                            }
                        </div></>
                )}
            </IonContent>}
        </IonPage>
    );
};

export default PhotoCapture;
